import { render, staticRenderFns } from "./Classes.vue?vue&type=template&id=7af1f946&lang=pug&"
import script from "./Classes.vue?vue&type=script&lang=ts&"
export * from "./Classes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports